import { createActions, createReducer } from 'reduxsauce'

import EventosObrasService from '../../servicos/EventosObrasService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEventosObrasInicio: [],
    buscaEventosObrasSucesso: ['eventosObras'],
    buscaEventosObrasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEventosObras = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEventosObrasInicio())
        let serv = new EventosObrasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaEventosObrasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEventosObrasErro(error)))
    }
}

const buscaEventosObrasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEventosObrasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEventosObrasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.eventosObras, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EVENTOS_OBRAS_INICIO]: buscaEventosObrasInicio,
    [Types.BUSCA_EVENTOS_OBRAS_ERRO]: buscaEventosObrasErro,
    [Types.BUSCA_EVENTOS_OBRAS_SUCESSO]: buscaEventosObrasSucesso,
})
